export const environment = {
  production: false,
  apiEndpoint: "https://uat.bmsapi.wbsolution.co",
  signalREndpoint: "https://uat.bmsapi.wbsolution.co/hubs/notification",
  cached : true,
};
